/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { clsx } from 'clsx'
import { memo, useState, useEffect, useRef } from 'react'

import { useWindowDimensions } from '@shared/lib/useWindowDimensions'
import { Btn } from '@shared/ui/btn'
import { FullCenterContent } from '@shared/ui/wrappers'

import styles from './styles.module.scss'

const animation = 'animate__animated animate__fadeIn animate__faster'

// ? TODO always show additional close button at top-right

const FCModalForm = ({
  children,
  disabled,
  //
  // id,
  type,
  title,
  buttons,
  functions,
  //
  fixPosition,
  //
  eventModal,
  //
  enableBgExit,
  enableModalExit,
  //
  noWrapper,
}) => {
  const windowDimensions = useWindowDimensions()
  const modalRef = useRef(null)

  const [positionAdjustment, setPositionAdjustment] = useState({ x: 0, y: 0 })

  const previousHeight = useRef(0)

  //
  //

  useEffect(() => {
    const checkInt = setInterval(() => {
      if (!modalRef.current) {
        return
      }

      const { height } = modalRef.current.getBoundingClientRect()

      if (previousHeight.current !== height) {
        previousHeight.current = height

        setPositionAdjustment({ x: 0, y: 0 })
      }
    }, 300)

    return () => clearInterval(checkInt)
  }, [])

  // * Checking right position and bottom position
  useEffect(() => {
    const checkFn = () => {
      if (
        !eventModal ||
        !modalRef.current ||
        positionAdjustment.x !== 0 ||
        positionAdjustment.y !== 0
      ) {
        return
      }

      //
      //

      const positions = { x: 0, y: 0 }

      //

      const { x, y, width, height } = modalRef.current.getBoundingClientRect()

      const { width: clientWidth, height: clientHeight } = windowDimensions

      // x
      const differenceX = x + width - clientWidth

      if (differenceX > 0) {
        positions.x = differenceX + 10
      }

      // y
      const differenceY = y + height - clientHeight

      if (differenceY > 0) {
        positions.y = differenceY + 10
      }

      //
      //

      // console.log(
      //   'Setting position adjustment: ',
      //   x,
      //   y,
      //   width,
      //   height,
      //   clientWidth,
      //   clientHeight,
      //   positions
      // )

      setPositionAdjustment(positions)
    }

    //
    //

    checkFn()

    const checkInt = setInterval(checkFn, 500)

    return () => clearInterval(checkInt)
  }, [eventModal, positionAdjustment.x, positionAdjustment.y, windowDimensions])

  //
  //

  const contentInside = (
    <div className={styles['modal-form-wrapper']}>
      {enableBgExit && (
        <div
          className={styles['modal-form-wrapper-close-bg']}
          onClick={functions.onReject}
        />
      )}
      <div
        ref={modalRef}
        className={clsx(
          animation,
          styles['modal-form'],
          styles[`modal-form_${type || 'default'}`],
          {
            [styles['modal-form_absolute']]: !!eventModal,
            [styles['modal-form_priority']]: !!noWrapper,
          }
        )}
        style={
          eventModal
            ? {
                top: eventModal.top - positionAdjustment.y,
                left: eventModal.left - positionAdjustment.x,
              }
            : null
        }
      >
        {enableModalExit && (
          <div
            className={styles['modal-form-wrapper-close-bg__icon']}
            onClick={functions.onReject}
          >
            <svg
              width="14"
              height="15"
              viewBox="0 0 14 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14 1.66958L12.585 0.198425L7 6.00505L1.415 0.198425L0 1.66958L5.585 7.4762L0 13.2828L1.415 14.754L7 8.94735L12.585 14.754L14 13.2828L8.415 7.4762L14 1.66958Z"
                fill="white"
              />
            </svg>
          </div>
        )}
        {title && <h2 className={styles['modal-form__title']}>{title}</h2>}
        <div className={styles['modal-form__content']}>{children}</div>
        {!!buttons?.length && (
          <div className={styles['modal-form__buttons']}>
            {buttons.map(({ action, text, variant_ }) => (
              <Btn
                key={text}
                // variant={variant || 'primary'}
                styles={['fwidth_auto']}
                onClick={functions[action]}
              >
                {text}
              </Btn>
            ))}
          </div>
        )}
      </div>
    </div>
  )

  //
  //

  if (noWrapper) {
    return contentInside
  }

  //
  //

  return (
    <div
      className={clsx('modal', {
        [styles['disabling-wrapper']]: disabled,
      })}
    >
      <FullCenterContent
        animation={animation}
        lightBg
        fixPosition={fixPosition}
        disabledBg={eventModal}
        allowOverflow
      >
        {contentInside}
      </FullCenterContent>
    </div>
  )
}

export const ModalForm = memo(FCModalForm)
